import {
  ViewKanban,
  Assignment,
  RequestQuote,
  Receipt,
  LocalShipping,
  Business,
  People,
  Settings,
  Tune,
  AccessTime,
  HomeWork,
  Factory,
  ManageAccounts,
  ViewList,
  Badge, 
  CorporateFare, 
  CalendarMonth,
  Work,
  EventNote,
  Policy,
  VpnKey,
  Security,  
  Category,
  Label,  
  Description
} from '@mui/icons-material';
import type { SvgIconComponent } from '@mui/icons-material';

export interface MenuLeafItem {
  kind: 'leaf';
  id: string;
  label: string;
  icon: SvgIconComponent;
  path: string;
  disabled: boolean;
}

export interface MenuGroupItem {
  kind: 'group';
  id: string;
  label: string;
  icon: SvgIconComponent;
  children: MenuEntry[];
}

export type MenuEntry = MenuLeafItem | MenuGroupItem;

export interface MenuSection {
  sectionLabel?: string;
  entries: MenuEntry[];
}

const leaf = (
  id: string,
  label: string,
  icon: SvgIconComponent,
  path: string,
  disabled = false,
): MenuLeafItem => ({ kind: 'leaf', id, label, icon, path, disabled });


const group = (
  id: string,
  label: string,
  icon: SvgIconComponent,
  children: MenuEntry[],
): MenuGroupItem => ({ kind: 'group', id, label, icon, children });

export const MENU_SECTIONS: MenuSection[] = [
  {
    entries: [
      group('production', 'Production', Factory, [
        group('kanban', 'Kanban', ViewKanban, [
        ]),
        leaf('taches', 'Tâches', Assignment, '/taches', false),
        leaf('soumissions', 'Soumissions', RequestQuote, '/soumissions', true),
      ]),

      group('facturation', 'Facturation & Livraison', Receipt, [
        leaf('factures', 'Factures', Receipt, '/factures', false),
        leaf('livraisons', 'Livraisons', LocalShipping, '/livraisons', true),
        leaf('transporteurs', 'Transporteurs', LocalShipping, '/transporteurs', true),
      ]),

      group('clients', 'Clients', People, [
        leaf('fiches-clients', 'Fiches clients', Business, '/clients', false),
      ]),
      
      group('espace-temps', 'Temps et absences', AccessTime, [
        leaf('employees-timesheets', 'Mes feuilles de temps', AccessTime, '/timesheets', false),
        leaf('employee-leaves', 'Mes congés', EventNote, '/my-leaves', false), 
        leaf('employees-planning', 'Calendrier', CalendarMonth, '/planning', false),
      ]),
     group('securite', 'Sécurité', Security, [
        leaf('mes-mots-de-passe', 'Mes mots de passe', VpnKey, '/mes-passwords', false),
        leaf('mots-de-passe-partages-recus', 'Partagés avec moi', Label, '/mes-passwords/partages', false),
      ]),
    ],
  },
  {
    sectionLabel: 'Configuration',
    entries: [
      group('configuration', 'Configuration', Settings, [
        leaf('formulaires', 'Formulaires', Assignment, '/config/formulaires', false),
        group('kanbans-group', 'Kanbans', ViewKanban, [
          leaf('type-kanbans', 'Types de Kanbans', Category, '/config/kanbans/types', false),
          leaf('liste-kanban', 'Liste de Kanbans', ViewList, '/config/kanbans/liste', false),
        ]),
      ]),
      group('administration', 'Administration', HomeWork, [
        group('gestion-employes', 'Employés', Badge, [
          leaf('employees-planning', 'Calendrier', CalendarMonth, '/planning', false),
          leaf('employees-timesheets', 'Feuilles de temps', AccessTime, '/timesheets', false),
          leaf('leave-requests', 'Demandes de congés', EventNote, '/admin/leave-requests', false), 
          leaf('employees-liste', 'Liste des employés', People, '/admin/employees', false),
          
          // --- ÉCRANS RH --- 
          leaf('employment-contracts', "Contrats d'emploi", Description, '/admin/employees/employment-contracts', false),
          leaf('policy-profiles', 'Profils RH', Policy, '/admin/employees/policy-profiles', false),
          leaf('employees-departments', 'Départements', CorporateFare, '/admin/employees/departments', false),
          leaf('employees-job-titles', 'Postes', Work, '/admin/employees/job-titles', false),
        ]),
        group('gestion-utilisateurs', 'Utilisateurs', ManageAccounts, [
          leaf('users-liste', 'Liste des utilisateurs', People, '/admin/users', false),
          leaf('users-roles', 'Rôles & Groupes', Tune, '/admin/users/roles', false),
        ]),
        // Groupe Sécurité
        group('gestion-securite', 'Sécurité', Security, [
          leaf('mots-de-passe', 'Mots de passe', VpnKey, '/admin/security/passwords', false),
          leaf('mots-de-passe-partages', 'Mots de passe partagés', VpnKey, '/admin/security/password-shares', false),
          leaf('types-acces', "Types d'accès", Category, '/admin/security/types', false), 
          leaf('categories-mdp', 'Catégories', Label, '/admin/security/categories', false),
          leaf('historique-acces', 'Historique des accès', Description, '/admin/security/audit-logs', false),
        ]),
        leaf('entreprises', 'Entreprises', HomeWork, '/entreprises', false),
      ]),
    ],
  },
];